














import {Component} from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import {mixins} from 'vue-class-component';
import {TagHelper} from '@/mixins/TagHelper';

@Component({
    components: {Button}
})
export default class Labels extends mixins(TagHelper) {
    get tags() {
        return this.$store.state.tagList;
    }
    created(){
        this.$store.commit('fetchTags');
    }
}
